import {SUCCESS} from "../../../../constants/action-postfix";
import {GRADUATES_HEO_REQUEST} from "../graduatesHEOReducer";


const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GRADUATES_HEO_REQUEST}${SUCCESS}`:
            return action.payload;
        default:
            return state;
    }
};